import { menuselect } from "@/constant/menuselect";
import router from "@/router";

let str = "智慧设备・资产管理平台";
export const config = {
  title: "设备·资产管理",
  headerInfo:
    "聚焦于提升医院设备、资产的管理效率，确保资产的安全和完整，优化资源配置，支持决策制定，以及实现资产信息的透明化和共享。",
  headerImg: require("@/assets/images/equipAssets/Rectangle 19header.png"),
  activeTitle: str,
  activeSubTitle: str,

  navList: [
    {
      name: "设备·资产管理",
      children: menuselect(),
    },
    {
      name: "智慧设备・资产管理平台",
      desc: "敬在医院智慧设备资产管理平台是敬在团队基于国内外标准和最佳业务实践，深度融合医院运营管理、PDCA循环管理理念，应用移动互联网、物联网等技术，针对医疗行业设备管理业务，自主研发的一款“一站式医院设备资产·管理平台”。具有部署方便、运维成本低、操作便捷、上手简单等特点。全方位解决医院设备管理痛点，助力医院改善设备管理水平，提高设备运行效率和利用率、降低设备使用风险和设备维护成本。帮助医疗机构实现设备管理的精细化、数字化、移动化和智能化。",
      tabList: [{}],
      [str]: [
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/equipAssets/Frame 1040one.png"),
        },
        {
          title: "应用价值",
          desc: " ",
          img: require("@/assets/images/equipAssets/Group 1040one.png"),
        },
      ],
    },
    {
      name: "资产管理",
      desc: "敬在资产管理系统支持对资产的全生命周期管理，包括资产预算管理，资产采购申请，资产采购合同，资产采购入库，资产新增入账，资产变动调整，资产转移、资产维修，资产折旧，资产报废，资产盘点等，从资产的计划、采购、新增到最终报废完成闭环管理。",
      tabList: [{}],
      [str]: [
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/equipAssets/Frame 1041two.png"),
        },
        {
          title: "",
          desc: "亮点方案一：资产产品管理资产采购产品目录基本信息，支持建立医疗器械分类目录、国标分类、财务分类等多套分类的映射关系",
          img: require("@/assets/images/equipAssets/Group 1042two.png"),
        },
        {
          title: "",
          desc: "亮点方案二：财务、归口、科室卡片信息丰富易用三账一卡便捷查询资产全生命周期信息",
          img: require("@/assets/images/equipAssets/Group 1043two.png"),
        },
        {
          title: "",
          desc: "亮点方案三：建立医院资产三级管理体系，实现精准台账",
          img: require("@/assets/images/equipAssets/Group 1044two.png"),
        },
      ],
    },
    {
      name: "设备管理",
      desc: "“一站式”医院设备智慧管理平台，全面提升医院设备管理效率，降低设备使用风险，系统涵盖设备日常保养维修管理，设备档案及台账管理，pc和移动多终端管理方式，提供设备单机效益分析、开机利用率、故障情况分析等指标报告，辅助医院采购决策。",
      tabList: [{}],
      [str]: [
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/equipAssets/Group 1046three.png"),
        },
        {
          title: "核心功能",
          desc: " ",
          img: require("@/assets/images/equipAssets/Group 1047three.png"),
        },
        {
          title: "",
          desc: "亮点方案一：连接医院和服务商，实现云上高效维保协同",
          img: require("@/assets/images/equipAssets/Frame 1048three.png"),
        },
        {
          title: "",
          desc: "亮点方案二：维修处理即时反馈，工单任务尽在指尖",
          img: require("@/assets/images/equipAssets/Frame 1049three.png"),
        },
        {
          title: "",
          desc: "亮点方案三：基于PDCA设备PM、质控管理，确保设备质量，降低设备使用风险。",
          img: require("@/assets/images/equipAssets/Frame 1049three-1.png"),
        },
        {
          title: "",
          desc: "",
          img: require("@/assets/images/equipAssets/Frame 795three.png"),
        },
        {
          title: "",
          desc: "",
          img: require("@/assets/images/equipAssets/Frame 796three.png"),
        },
      ],
    },
    {
      name: "单机效益分析",
      desc: "敬在大型设备效益分析平台，通过信息技术与物联网技术，采集并处理单台设备收入、成本及工作量数据；按照平台设备效益分析指标库，输出各项设备分析指标，利用智能管理大屏进行数据可视化展示。",
      tabList: [{}],
      [str]: [
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/equipAssets/Group 1058five.png"),
        },
        {
          title: "应用价值",
          desc: " ",
          img: require("@/assets/images/equipAssets/Group 1059five.png"),
        },
        {
          title: "",
          desc: "大型设备效益分析：指标体系示例(部分）",
          img: require("@/assets/images/equipAssets/Frame 1055five.png"),
        },
        {
          title: "",
          desc: "大型设备效益分析：指标体系示例(部分）",
          img: require("@/assets/images/equipAssets/Frame 1056five.png"),
        },
        {
          title: "",
          desc: "",
          img: require("@/assets/images/equipAssets/Frame 794five.png"),
        },
        {
          title: "",
          desc: "建立多维度的资产效益分析和可视化工具",
          img: require("@/assets/images/equipAssets/Frame 1058five.png"),
        },
        {
          title: "",
          desc: "单机设备经济效益分析",
          img: require("@/assets/images/equipAssets/Frame 1059five.png"),
        },
      ],
    },
  ],
};
